// extracted by mini-css-extract-plugin
export default {"header":"BFHeader_header__R8ZQX","logo-container":"BFHeader_logo-container__0d1AR","current-view-info":"BFHeader_current-view-info__8Z3rm"};